/* eslint-disable react/jsx-no-bind */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';
import urls from '../../constants/urls.js';
import ArtistService from '../../services/artistService.js';
import LoginButtons from './LoginButtons';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as accountActions from '../../actions/accountActions';
import UserOptions from './UserOptions.js';
import logo from '../../images/logo-loudup-new.png';

const Nav = (props) => { 
    const landing = props.location.pathname === "/Intro";

    const toggleSideNav = (e) => {
        e.preventDefault();
        e.stopPropagation();
        $('body').toggleClass('showside');
        //$('body').removeClass('showplayer');
        //$('body').removeClass('showsearch');
    };    

    const closeUserDropDown = () => {

    };

    return (
        <nav id="navbar" className="navbar navbar-default navbar-blank" role="navigation">
            <div>
                <div className="navbar-header">
                    <button type="button" className="navbar-toggle navbar-side" onClick={toggleSideNav}>
                        <span className="sr-only">Toggle navigation</span>
                        <span className="icon-bar bar1 transition" />
                        <span className="icon-bar bar2 transition" />
                        <span className="icon-bar bar3 transition" />
                    </button>
                    <Link to={landing ? '/Intro' : '/'} className="navbar-brand">
                        <img src={logo} alt="Logo for LoudUp - Music Social Network" title="LoudUp - Music Social Network" />
                        <p className="tagline">Music Social Network</p>
                    </Link>
                </div>
                {
                    !landing ?
                        <React.Fragment>                            
                            {
                                props.user ?
                                    <ul className="nav navbar-nav navbar-nav-mobile">
                                        <li className="inbox-link">
                                            <Link to="/Messages" id="lnkInbox" className="btn-notification btn-inbox transition">
                                                {
                                                    props.user && props.user.activeProfile && props.user.activeProfile.UnreadEmailCount ?
                                                        <span className="inbox-bubble">{props.user.activeProfile.UnreadEmailCount}</span>
                                                        : null
                                                }
                                                <svg className="icon transition">
                                                    <use xlinkHref="#icn-email" />
                                                </svg>
                                            </Link>
                                        </li>
                                        <li className="inbox-link">
                                            <Link to="/Notifications" id="lnkNotifications" href="#" className="btn-notification btn-inbox transition">
                                                {
                                                    props.user && props.user.activeProfile && props.user.activeProfile.UnreadNotificationCount ?
                                                        <span className="inbox-bubble">{props.user.activeProfile.UnreadNotificationCount}</span>
                                                        : null
                                                }
                                                <svg className="icon transition">
                                                    <use xlinkHref="#icn-bell" />
                                                </svg>
                                            </Link>
                                        </li>
                                    </ul>
                                : null
                            }  
                            <div className="collapse navbar-collapse" id="drop-menu">
                                <ul className="nav navbar-nav navbar-nav-center">
                                    <li><Link to="/HowItWorks" className="transition">HOW IT WORKS</Link></li>
                                    <li className="dropdown">
                                        <a href="#" className="dropdown-toggle transition" data-toggle="dropdown">EXPLORE <span className="caret" /></a>
                                        <ul className="dropdown-menu" role="menu">
                                            <li><Link to="/Fans">Fans</Link></li>
                                            <li><Link to="/Artists">Artists/Bands</Link></li>
                                            <li><Link to="/Producers">Producers</Link></li>
                                            <li><Link to="/Musicians">Musicians</Link></li>
                                            <li><Link to="/RecordLabels">Record Labels</Link></li>
                                            <li><Link to="/Songwriters">Songwriters</Link></li>
                                            <li><Link to="/Venues">Venues</Link></li>
                                            <li><Link to="/Promoters">Promoters</Link></li>
                                            <li><Link to="/Managers">Managers</Link></li>
                                            <li><Link to="/RecordingStudios">Recording Studios</Link></li>
                                            <li><Link to="/RecommendedLinks">Recommended Links</Link></li>
                                        </ul>
                                    </li>
                                    <li><Link to="/Gigs" className="transition">GO</Link></li>
                                    <li className="dropdown">
                                        <a href="#" className="dropdown-toggle transition" data-toggle="dropdown">CHATTER <span className="caret" /></a>
                                        <ul className="dropdown-menu" role="menu">
                                            <li><Link to="/Discussions" className="transition">Discussions</Link></li>
                                            <li><Link to="/ActivityFeed" className="transition">Activity Feed</Link></li>
                                            <li><Link to="/Charts" className="transition">Trending</Link></li>
                                            <li><Link to="/Announcements" className="transition">Announcements</Link></li>
                                        </ul>
                                    </li>
                                    <li><Link to="/Discover" className="transition">DISCOVER</Link></li>
                                    <li className="dropdown">
                                        <a href="#" className="dropdown-toggle transition" data-toggle="dropdown">READ <span className="caret" /></a>
                                        <ul className="dropdown-menu" role="menu">
                                            <li><Link to="/Blog" className="transition">Blog</Link></li>
                                            <li><Link to="/Unsigned" className="transition">Unsigned Guide</Link></li>
                                            <li><Link to="/PromoteYourMusic" className="transition">Promote Your Music</Link></li>
                                            <li><Link to="/LyricVideo" className="transition">Create A Lyric Video</Link></li>
                                        </ul>
                                    </li>
                                </ul>
                                <ul className="nav navbar-nav navbar-right">
                                    {props.user ?     
                                        <React.Fragment>              
                                            <li className="dropdown" id="userOptions">
                                                <a href="#" className="navbar-user dropdown-toggle transition" data-toggle="dropdown">
                                                    <span className="avatar">
                                                        <svg className="icon icn-user transition">
                                                            <use xlinkHref="#icn-user" />
                                                        </svg>
                                                    </span>
                                                    {props.user.activeProfile ? <span className="username">ME</span> : <span className="username" style={{fontSize: '12px', maxWidth: '120px'}}>No profiles created yet</span>}
                                                    <span className="caret" />
                                                </a>
                                                <ul className="dropdown-menu" role="menu">
                                                    <UserOptions actions={props.actions} user={props.user} />
                                                </ul>
                                            </li>                                            
                                            <li className="inbox-link">
                                                <Link to="/Messages" id="lnkInbox" className="btn-notification btn-inbox transition">
                                                    {
                                                        props.user && props.user.activeProfile && props.user.activeProfile.UnreadEmailCount ?
                                                            <span className="inbox-bubble">{props.user.activeProfile.UnreadEmailCount}</span>
                                                            : null
                                                    }
                                                    <svg className="icon transition">
                                                        <use xlinkHref="#icn-email" />
                                                    </svg>
                                                </Link>
                                            </li>
                                            <li className="inbox-link">
                                                <Link to="/Notifications" id="lnkNotifications" className="btn-notification btn-inbox transition">
                                                    {
                                                        props.user && props.user.activeProfile && props.user.activeProfile.UnreadNotificationCount ?
                                                            <span className="inbox-bubble">{props.user.activeProfile.UnreadNotificationCount}</span>
                                                            : null
                                                    }
                                                    <svg className="icon transition">
                                                        <use xlinkHref="#icn-bell" />
                                                    </svg>
                                                </Link>
                                            </li>   
                                        </React.Fragment>     
                                        :
                                        <li>
                                            <LoginButtons />
                                        </li>
                                    }                  
                                </ul>
                            </div>
                        </React.Fragment>
                    : 
                        <div className="collapse navbar-collapse" id="drop-menu">
                            <ul className="nav navbar-nav navbar-right">
                                <li>
                                    <LoginButtons />
                                </li>
                            </ul>
                        </div>
                }
            </div>
        </nav>            
    );
};

function mapStateToProps(state, ownProps) {
    return { user: state.account.user };
}

function mapDispatchToProps(dispatch) {
    return {
        //account actions will now be available under this.props.actions
        actions: bindActionCreators(Object.assign({}, accountActions), dispatch)
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Nav));

Nav.propTypes = {
    user: PropTypes.object,
    location: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired
};